import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { ModalContent } from '@src/shared/modal/confirm-modal/confirm-modal.type';
import { ModalService } from '@src/shared/modal/modal.service';
import { CampaignService } from '../../../../woo_services.module/CampaignService';
import { RoutingService } from '../../../../woo_services.module/RoutingService';
import { Campaign } from '../../../../woo_services.module/shared-types';

@Component({
  selector: 'close-campaign-button',
  template: ` <text-button icon="close-x" [disabled]="disabled" (click)="onClick()"> Stäng </text-button> `,
  standalone: false,
})
export class CloseCampaignButton {
  @Input() campaign: Campaign;
  @Input() disabled = false;

  constructor(
    private campaignService: CampaignService,
    private routingService: RoutingService,
    private modalService: ModalService,
  ) {}

  onClick = (): void => {
    if (this.disabled) {
      return;
    }

    const content = this.getDialogContent();
    this.modalService.openConfirm(content).then(
      (response) => {
        if (response.confirm) {
          this.closeCampaign(this.campaign, response.message);
        }
      },
      () => null,
    );
  };

  private closeCampaign = (campaign: Campaign, comment: string) => {
    this.campaignService
      .close(campaign.id, comment)
      .then(
        () => {
          this.modalService.openSuccess('Kampanjen har stängts.');
          this.routingService.navigate(['/dashboard']);
        },
        (reason) => {
          if (!(reason instanceof HttpErrorResponse)) {
            const msg = 'Ajdå, något gick snett. Din kampanj kunde inte stängas.';
            this.modalService.openError(msg);
          }
        },
      )
      .catch(() => {
        const msg = 'Ajdå, nånting gick snett. Testa att refresha browsern och försök igen.';
        this.modalService.openError(msg);
      });
  };

  private getDialogContent = (): ModalContent => ({
    title: 'Stäng avslutad kampanj',
    texts: [`Är du säker på att du vill stänga <strong>${this.campaign.name}</strong>?`],
    comment: {
      label: 'Kommentar för stängning',
      required: true,
      text: '',
    },
    confirmLabel: 'Stäng kampanj',
    cancelLabel: 'Avbryt',
  });
}
